import React from 'react'

import styled, { useTheme } from "styled-components"

import features from "../../../assets/features.png"
import featureMobile from "../../../assets/feature-mobile.png"
import { H3, P } from '../../styleguide/typography'

import { BsChevronCompactDown } from 'react-icons/bs';

const MoreFeatures = () => {
  const theme = useTheme();
  return (
    <StyledFeatures>
        <P 
          color={theme.colors.secondary} 
          textTransform="uppercase" 
          weight={theme.fontWeights.bold}
        >
          MORE
        </P>

        <H3 
          color={theme.colors.primary} 
          textTransform="uppercase" 
          weight={theme.fontWeights.bold}
          margin="1rem 0 0 0"
        >
          FEATURES
        </H3>

        <Icon />
        <img className='web' draggable="false" src={features} alt="features" />
        <img className='mobile' draggable="false" src={featureMobile} alt="features" />
    </StyledFeatures>
  )
}

export default MoreFeatures

const StyledFeatures = styled.div`
    width: 100vw;
    min-height: 100vh;
    background: #fff;
    padding: 3rem 8%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
        width: 100%;
        height: auto;

        &.mobile {
            display: none;
        }
    }

    @media (max-width: 768px) {
        padding: 3rem 0;
        /* padding-right: 1rem; */

        img {
            &.web {
                display: none;
            }
    
            &.mobile {
                display: block;
            }
        }
    }
`

const Icon = styled(BsChevronCompactDown)`
  font-size: 2.5rem;
  color: ${({ theme }) => theme.colors.secondary};
  margin: 0 auto;
  margin-bottom: 2rem;
`